import { expandDepartureGroup } from "../../configurazione/adapters";
import {
  bozzaDaRicerca,
  normalizzaMongoFilters,
} from "../selezioneRicercaOrdini";
import { useLogisticaConfiguration } from "../../configurazione/LogisticaConfigurationProvider";
import React, { useEffect, useMemo, useState } from "react";
import apiUrl from "../../../Apiurl";
import { useAuth0 } from "@auth0/auth0-react";
import {
  Calendar,
  Database,
  FileText,
  Filter,
  Globe2,
  Hash,
  Image,
  Layers,
  Package,
  Tags,
  User,
  Users,
  Truck,
  Payments,
  DirtyLens,
  IDCard,
  LocationON,
  Automation,
} from "../../../interfaccia/advancedSearch/advancedSearchIcons";
import CampoRicercaAvanzata from "./CampoRicercaAvanzata";
import { dateSpedizioniInStallo } from "./filtriVelociOrdini";
import CategorieWebSub from "../../../modificaProdotti/moduliArticolo/CategorieWebSub";
import { buildMongoArticoliFiltersConfig } from "../../../moda/mongoArticoliFiltersConfig";
import {
  AdvancedSearchField,
  AdvancedSearchFieldRow,
  AdvancedSearchLayout,
  AdvancedSearchValuePicker,
  isAdvancedSearchValueActive,
} from "../../../interfaccia/advancedSearch/AdvancedSearchLayout";



// Viste i cui endpoint applicano fattureFiltro (ricercaOrdiniDBavanzataPagination e ricercaAttese).
const VISTE_FILTRO_FATTURE = new Set([undefined, "", "ordini", "note", "attese", "controlliCorrispettivi"]);

const SQL_NOT_IN_TOOLTIP =
  "Per i filtri SQL in NOT IN vengono restituiti solo gli articoli con campo valorizzato.";

const MONGO_NOT_IN_TOOLTIP =
  "Per i filtri pubblicazione, NOT IN include anche articoli mai pubblicati o con campo non valorizzato.";

const MODA_SQL_FILTERS = [
  {
    key: "brand",
    label: "Brand",
    eqKey: "m.brand =",
    includeKey: "m.brand IN",
    excludeKey: "m.brand NOT IN",
    lookupKey: "brand",
    icon: Tags,
  },
  {
    key: "reparto",
    label: "Reparto",
    eqKey: "m.reparto =",
    includeKey: "m.reparto IN",
    excludeKey: "m.reparto NOT IN",
    lookupKey: "reparto",
    icon: Database,
  },
  {
    key: "categoria",
    label: "Categoria",
    eqKey: "m.categoria =",
    includeKey: "m.categoria IN",
    excludeKey: "m.categoria NOT IN",
    lookupKey: "categoria",
    icon: Tags,
  },
  {
    key: "tipo",
    label: "Tipo",
    eqKey: "m.tipo =",
    includeKey: "m.tipo IN",
    excludeKey: "m.tipo NOT IN",
    lookupKey: "tipo",
    icon: Package,
  },
  {
    key: "sottotipo",
    label: "Sottotipo",
    eqKey: "m.sottotipo =",
    includeKey: "m.sottotipo IN",
    excludeKey: "m.sottotipo NOT IN",
    lookupKey: "sottotipo",
    icon: Package,
  },
  {
    key: "persona",
    label: "Persona",
    eqKey: "m.persona =",
    includeKey: "m.persona IN",
    excludeKey: "m.persona NOT IN",
    lookupKey: "persona",
    icon: User,
  },
  {
    key: "stagione",
    label: "Stagione",
    eqKey: "m.stagione =",
    includeKey: "m.stagione IN",
    excludeKey: "m.stagione NOT IN",
    lookupKey: "stagione",
    icon: Calendar,
  },
];

const LEGACY_MODA_TEXT_FILTERS = new Set(
  MODA_SQL_FILTERS.map((item) => item.eqKey),
);

const DEFAULT_MODA_FILTER_MODES = Object.fromEntries(
  MODA_SQL_FILTERS.map((field) => [field.key, "in"]),
);

const modaFilterModesDaInput = (input) =>
  MODA_SQL_FILTERS.reduce((modes, field) => {
    if (input[field.excludeKey]?.length) modes[field.key] = "not_in";
    else if (input[field.eqKey]) modes[field.key] = "eq";
    return modes;
  }, { ...DEFAULT_MODA_FILTER_MODES });

// Draft of the applied selection: SQL criteria in `input`, Mongo criteria in
// their own state, as runSearch merges them back.
const bozzaPopupDaRicerca = (ricerca, groups) => {
  const { mongoFilters, ...input } = bozzaDaRicerca(ricerca, groups);
  return { input, mongoFilters: normalizzaMongoFilters(mongoFilters) };
};

const ADVANCED_SEARCH_ICON_MAP = {
  Calendar,
  Database,
  FileText,
  Filter,
  Globe2,
  Hash,
  Image,
  Layers,
  Package,
  Tags,
  User,
  Users,
  Truck,
  Payments,
  DirtyLens,
  IDCard,
  LocationON,
  Automation,
};

const resolveAdvancedSearchIcon = (icon, fallback = Hash) => {
  if (typeof icon === "function") return icon;
  if (typeof icon === "string" && ADVANCED_SEARCH_ICON_MAP[icon])
    return ADVANCED_SEARCH_ICON_MAP[icon];
  return fallback;
};

const CATEGORY_VALUE_FILTERS = [
  {
    key: "categoriaPredefinita",
    label: "Categoria predefinita",
    includeKey: "categoriaPredefinita_in",
    icon: Globe2,
    help: "La categoria predefinita dell'articolo puo essere una sola. Se selezioni piu categorie, la ricerca restituisce articoli la cui categoria predefinita corrisponde ad almeno uno dei valori scelti.",
  },
  {
    key: "categorieWeb",
    label: "Categorie associate",
    includeKey: "categorieWeb_in",
    modeKey: "categorieWeb_in_match",
    icon: Globe2,
    help: "ALMENO UNA restituisce articoli che hanno una qualsiasi categoria selezionata. TUTTE restituisce articoli che hanno tutte le categorie selezionate.",
  },
  {
    key: "categorieWebNot",
    label: "Categorie NON associate",
    includeKey: "categorieWeb_not_in",
    modeKey: "categorieWeb_not_in_match",
    icon: Globe2,
    help: "TUTTE ASSENTI restituisce articoli che non hanno nessuna categoria selezionata. NE MANCA ALMENO UNA restituisce articoli che non hanno almeno una delle categorie selezionate.",
  },
];

const normalizeLookupRecords = (payload) => {
  const list = Array.isArray(payload?.data)
    ? payload.data
    : Array.isArray(payload)
      ? payload
      : [];
  return list
    .map((item) => {
      if (item == null) return null;
      if (typeof item === "string") {
        const value = item.trim();
        return value ? { code: value, description: value } : null;
      }
      const code =
        item.code ??
        item.codice ??
        item.cod ??
        item.id ??
        item.value ??
        item.slug ??
        item.key ??
        item.ID;
      if (code === undefined || code === null || String(code).trim() === "")
        return null;
      const description =
        item.description ??
        item.descrizione ??
        item.label ??
        item.nomeDisplay ??
        item.nome_display ??
        item.nome ??
        item.name ??
        item.desc ??
        code;
      return {
        code: String(code).trim(),
        description: String(description ?? code).trim(),
      };
    })
    .filter(Boolean);
};

const generateSeasonOptions = () => {
  const options = [];
  const currentYear = new Date().getFullYear();
  const lastYear = (currentYear % 100) + 1;
  for (let yy = 20; yy <= lastYear; yy += 1) {
    const yearStr = yy.toString().padStart(2, "0");
    options.push({ code: `${yearStr}1`, description: `${yearStr}1` });
    options.push({ code: `${yearStr}2`, description: `${yearStr}2` });
  }
  return options;
};

const getColumnMeta = (column, index) => {
  const titleField = column.find((field) => field?.titolo);
  return {
    title: titleField?.titolo || "Gruppo " + (index + 1),
    icon: resolveAdvancedSearchIcon(titleField?.icon, Filter),
  };
};

function RicercaAvanzataOrdiniPOP(props) {
  const { groups, tuttiIcampiRicerca } = useLogisticaConfiguration();

  const {
    setUrlRicerca,
    page,
    setPopUpWindow,
    campiRicerca = [],
    urlRicercaVista,
    setRicerca,
    noTitle,
    soloFiltri,
    vista,
    inputIniziale = {},
    ricerca,
    fetchOrdini,
  } = props || {};

  const { user, getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [bozzaIniziale] = useState(() =>
    bozzaPopupDaRicerca(ricerca ?? inputIniziale, groups),
  );
  const [input, setInput] = useState(bozzaIniziale.input);
  const [mongoFilters, setMongoFilters] = useState(bozzaIniziale.mongoFilters);
  const [activeTab, setActiveTab] = useState("sql-0");
  const [activeValueKey, setActiveValueKey] = useState("brand");
  const isArticoliView = vista === "articoli";
  const mostraFiltroFatture = VISTE_FILTRO_FATTURE.has(vista);
  const mostraFiltriVeloci = !vista || vista === "ordini";
  const [datiUlterioriStandard, setDatiUlterioriStandard] = useState({});
  const [modaLookupOptions, setModaLookupOptions] = useState({
    brand: [],
    reparto: [],
    categoria: [],
    tipo: [],
    sottotipo: [],
    persona: [],
  });
  const [modaFilterModes, setModaFilterModes] = useState(() =>
    modaFilterModesDaInput(bozzaIniziale.input),
  );
  const seasonOptions = useMemo(() => generateSeasonOptions(), []);

  const sqlColumns = useMemo(() => {
    if (isArticoliView) return campiRicerca.map((column) =>
      column.filter((field) => !LEGACY_MODA_TEXT_FILTERS.has(field?.nome)),
    );
    if (!mostraFiltroFatture) return campiRicerca;
    const configuredFields = campiRicerca.flatMap((column) =>
      column.flatMap((field) => field.campi ?? [field]),
    );
    const missingOrderDates = [
      tuttiIcampiRicerca.spedDataOrdineMaggioreEQ,
      tuttiIcampiRicerca.spedDataOrdineMinoreEQ,
    ].filter((field) => field && !configuredFields.some((item) => item.nome === field.nome));
    return missingOrderDates.length
      ? [...campiRicerca, [{ titolo: "Date ordine", icon: Calendar }, ...missingOrderDates]]
      : campiRicerca;
  }, [campiRicerca, isArticoliView, mostraFiltroFatture, tuttiIcampiRicerca]);

  const mongoConfig = useMemo(
    () => buildMongoArticoliFiltersConfig(datiUlterioriStandard),
    [datiUlterioriStandard],
  );
  const mongoSelectConfig = useMemo(
    () => mongoConfig.filter((item) => item.type !== "tree"),
    [mongoConfig],
  );
  const categorieWebTree = useMemo(
    () =>
      Array.isArray(datiUlterioriStandard?.categorieWeb)
        ? datiUlterioriStandard.categorieWeb
        : [],
    [datiUlterioriStandard],
  );

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    if (!token) {
      setDatiUlterioriStandard({});
      return;
    }
    const controller = new AbortController();
    fetch(apiUrl + "/prodotti/get/datiUlteriori", {
      headers: { Authorization: "Bearer " + token },
      signal: controller.signal,
    })
      .then((resp) => resp.json())
      .then((data) => setDatiUlterioriStandard(data || {}))
      .catch((error) => {
        if (!controller.signal.aborted) {
          console.error("Errore nel recupero dati ulteriori:", error);
        }
      });
    return () => controller.abort();
  }, [token]);

  useEffect(() => {
    if (!token || !isArticoliView) {
      setModaLookupOptions({
        brand: [],
        reparto: [],
        categoria: [],
        tipo: [],
        sottotipo: [],
        persona: [],
      });
      return;
    }
    const controller = new AbortController();
    const endpoints = [
      { key: "brand", url: "/moda/lookup/brand" },
      { key: "reparto", url: "/moda/lookup/reparti" },
      { key: "categoria", url: "/moda/lookup/categorie" },
      { key: "tipo", url: "/moda/lookup/tipi" },
      { key: "persona", url: "/moda/lookup/persona" },
      { key: "sottotipo", url: "/moda/lookup/sottotipi" },
    ];
    Promise.all(
      endpoints.map(async ({ key, url }) => {
        try {
          const response = await fetch(`${apiUrl}${url}`, {
            headers: { Authorization: "Bearer " + token },
            signal: controller.signal,
          });
          const data = await response.json();
          return { key, data: normalizeLookupRecords(data) };
        } catch (error) {
          if (!controller.signal.aborted) {
            console.error(`Errore nel recupero lookup ${key}:`, error);
          }
          return { key, data: [] };
        }
      }),
    ).then((results) => {
      if (!controller.signal.aborted) {
        setModaLookupOptions({
          brand: results.find((item) => item.key === "brand")?.data ?? [],
          reparto: results.find((item) => item.key === "reparto")?.data ?? [],
          categoria:
            results.find((item) => item.key === "categoria")?.data ?? [],
          tipo: results.find((item) => item.key === "tipo")?.data ?? [],
          sottotipo:
            results.find((item) => item.key === "sottotipo")?.data ?? [],
          persona: results.find((item) => item.key === "persona")?.data ?? [],
        });
      }
    });
    return () => controller.abort();
  }, [token, isArticoliView]);

  const handleChange = async function (evt) {
    const value = evt.target.value;
    setInput((prev) => ({ ...prev, [evt.target.name]: value }));
  };

  const getModaState = (field) => {
    const mode = modaFilterModes[field.key] ?? "in";
    if (mode === "eq")
      return { mode, values: input[field.eqKey] ? [input[field.eqKey]] : [] };
    if (mode === "not_in")
      return {
        mode,
        values: Array.isArray(input[field.excludeKey])
          ? input[field.excludeKey]
          : [],
      };
    return {
      mode,
      values: Array.isArray(input[field.includeKey])
        ? input[field.includeKey]
        : [],
    };
  };

  const updateModaValues = (field, mode, values) => {
    setModaFilterModes((prev) => ({ ...prev, [field.key]: mode }));
    setInput((prev) => {
      const next = { ...prev };
      delete next[field.eqKey];
      delete next[field.includeKey];
      delete next[field.excludeKey];
      if (mode === "eq" && values[0]) next[field.eqKey] = values[0];
      if (mode === "in" && values.length) next[field.includeKey] = values;
      if (mode === "not_in" && values.length) next[field.excludeKey] = values;
      return next;
    });
  };

  const getMongoSelectState = (field) => {
    const includeKey = `${field.key}_in`;
    const excludeKey = `${field.key}_not_in`;
    if (isAdvancedSearchValueActive(mongoFilters?.[excludeKey])) {
      return { mode: "not_in", values: mongoFilters?.[excludeKey] ?? [] };
    }
    return { mode: "in", values: mongoFilters?.[includeKey] ?? [] };
  };

  const updateMongoSelectValues = (field, mode, values) => {
    const includeKey = `${field.key}_in`;
    const excludeKey = `${field.key}_not_in`;
    setMongoFilters((prev) => {
      const next = { ...prev };
      delete next[includeKey];
      delete next[excludeKey];
      if (values.length)
        next[mode === "not_in" ? excludeKey : includeKey] = values;
      return next;
    });
  };

  const updateCategoryValues = (field, values) => {
    setMongoFilters((prev) => {
      const next = { ...prev };
      if (values.length) next[field.includeKey] = values;
      else delete next[field.includeKey];
      return next;
    });
  };

  const updateCategoryMode = (field, mode) => {
    if (!field.modeKey) return;
    setMongoFilters((prev) => ({ ...prev, [field.modeKey]: mode }));
  };

  const buildSearchParams = (source) => {
    const params = new URLSearchParams();
    Object.entries(source ?? {}).forEach(([key, value]) => {
      if (value === undefined || value === null || value === "") return;
      if (key === "mongoFilters" && typeof value === "object") {
        const normalized = normalizzaMongoFilters(value);
        if (Object.keys(normalized).length)
          params.set("mongoFilters", JSON.stringify(normalized));
        return;
      }
      params.set(key, value);
    });
    return params;
  };

  const runSearch = async () => {
    const mergedFilters = expandDepartureGroup(
      vista === "note"
        ? { ...input, mongoFilters, includeNote: "1" }
        : { ...input, mongoFilters },
      groups,
    );
    setRicerca(mergedFilters);
    if (soloFiltri) {
      setPopUpWindow && setPopUpWindow("");
    } else {
      setUrlRicerca(urlRicercaVista);
      const loaded = await fetchOrdini(page, urlRicercaVista, {
        ricerca: Object.fromEntries(buildSearchParams(mergedFilters)),
        headers: { Authorization: "Bearer " + token },
      });
      if (loaded) {
        setPopUpWindow && setPopUpWindow("");
      }
    }
  };

  const handleKeyDown = async function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      runSearch();
    }
  };

  const summaryEntries = useMemo(() => {
    const entries = [];
    Object.entries(input).forEach(([key, value]) => {
      if (Array.isArray(value) && value.length)
        entries.push([key, value.join(", "), "input:" + key]);
      else if (typeof value === "string" && value.trim())
        entries.push([key, value.trim(), "input:" + key]);
    });
    Object.entries(mongoFilters ?? {}).forEach(([key, value]) => {
      if (key.endsWith("_match")) return;
      if (Array.isArray(value) && value.length)
        entries.push([key, value.join(", "), "mongo:" + key]);
    });
    return entries;
  }, [input, mongoFilters]);

  const sqlTabs = sqlColumns.map((column, index) => {
    const meta = getColumnMeta(column, index);
    return {
      key: "sql-" + index,
      label: meta.title,
      icon: meta.icon,
      activeCount: column.reduce((count, field) => {
        if (field?.tipoLayout === "riga" && Array.isArray(field.campi)) {
          return (
            count +
            field.campi.filter((subField) =>
              isAdvancedSearchValueActive(input[subField.nome]),
            ).length
          );
        }
        return field?.nome && isAdvancedSearchValueActive(input[field.nome])
          ? count + 1
          : count;
      }, 0),
    };
  });
  const modaCount = MODA_SQL_FILTERS.filter(
    (field) => getModaState(field).values.length,
  ).length;
  const mongoWebCount = CATEGORY_VALUE_FILTERS.filter((field) =>
    isAdvancedSearchValueActive(mongoFilters[field.includeKey]),
  ).length;
  const mongoDataCount = mongoSelectConfig.filter(
    (field) => getMongoSelectState(field).values.length,
  ).length;
  const tabs = [
    ...sqlTabs,
    ...(!isArticoliView ? [{key:"magazzino",label:"Stato magazzino",icon:Package,activeCount:input.magazzinoFiltro?1:0}] : []),
    ...(mostraFiltroFatture ? [{ key: "fatture", label: "Fatture", icon: FileText, activeCount: input.fattureFiltro ? 1 : 0 }] : []),
    ...(mostraFiltroFatture ? [{
      key: "spedizione-corrispettivi",
      label: "Spedizione e corrispettivi",
      icon: Truck,
      activeCount: [input.spedizioneFiltro, input.corrispettiviFiltro].filter(Boolean).length,
    }] : []),
    ...(mostraFiltriVeloci ? [{ key: "filtri-veloci", label: "Filtri veloci", icon: Filter }] : []),
    ...(isArticoliView
      ? [
          {
            key: "moda",
            label: "Valori MODA",
            icon: Database,
            activeCount: modaCount,
          },
          {
            key: "mongo-web",
            label: "Categorie web",
            icon: Globe2,
            activeCount: mongoWebCount,
          },
          {
            key: "mongo-data",
            label: "Dati pubblicazione",
            icon: FileText,
            activeCount: mongoDataCount,
          },
        ]
      : []),
  ];

  const getSqlFieldInputStyle = (field) =>
    isAdvancedSearchValueActive(input[field.nome])
      ? {
          backgroundColor: "rgba(19, 119, 82, 0.08)",
          borderColor: "rgba(19, 119, 82, 0.5)",
        }
      : undefined;

  const renderSqlInput = (campo) => (
    <CampoRicercaAvanzata
      nomeCampo={campo.nome}
      labelCampo=""
      value={input[campo.nome] ?? ""}
      tipo={campo.tipo}
      handleChange={handleChange}
      handleKeyDown={handleKeyDown}
      dati={campo.dati}
      divClass="w-100"
      inputStyle={getSqlFieldInputStyle(campo)}
    />
  );

  const renderSqlColumn = (column) => (
    <div>
      {column.map((campo, index) => {
        if (campo.testo)
          return (
            <small key={index} className="db mb3 gray lh-copy">
              {campo.testo}
            </small>
          );
        if (campo.titolo)
          return (
            <div key={index} className="b mb3">
              {campo.titolo}
            </div>
          );
        if (campo.tipoLayout === "riga" && Array.isArray(campo.campi)) {
          const active = campo.campi.some((field) =>
            isAdvancedSearchValueActive(input[field.nome]),
          );
          return (
            <AdvancedSearchField
              key={campo.key ?? campo.label ?? index}
              label={campo.label}
              icon={resolveAdvancedSearchIcon(campo.icon, Hash)}
              active={active}
            >
              <AdvancedSearchFieldRow>
                {campo.campi.map((field) => (
                  <div key={field.nome}>
                    <div className="f7 ttu tracked gray b mb1">
                      {field.label}
                    </div>
                    {renderSqlInput(field)}
                  </div>
                ))}
              </AdvancedSearchFieldRow>
            </AdvancedSearchField>
          );
        }
        return (
          <AdvancedSearchField
            key={campo.nome}
            label={campo.label}
            icon={resolveAdvancedSearchIcon(campo.icon, Hash)}
            active={isAdvancedSearchValueActive(input[campo.nome])}
          >
            {renderSqlInput(campo)}
          </AdvancedSearchField>
        );
      })}
    </div>
  );

  const renderFilterColumn = () => {
    if (activeTab === "filtri-veloci" && mostraFiltriVeloci) return (
      <div className="pa3">
        <button type="button" className="tastoBianco pa2 br2 pointer" onClick={applicaSpedizioniInStallo}>
          Spedizioni in stallo
        </button>
        <p>Azzera tutti i criteri della bozza e imposta la data ordine sui tre mesi precedenti,
          le spedizioni non spedite e i soli corrispettivi (SI e split collegati).
          Puoi modificare i filtri nelle altre tab, poi premere Cerca.</p>
      </div>
    );
    if (activeTab === "spedizione-corrispettivi" && mostraFiltroFatture) return (
      <div className="pa3">
        <label htmlFor="spedizione-filtro">Spedizione</label>
        <select id="spedizione-filtro" name="spedizioneFiltro" className="db mt3 mb3 pa2 w-100"
          value={input.spedizioneFiltro || ""} onChange={handleChange}>
          <option value="">Nessun filtro spedizione</option>
          <option value="NON_SPEDITA">Non spedite (senza data partenza o stato pre-spedizione, esclusi annullati ed errori di pagamento)</option>
        </select>
        <label htmlFor="corrispettivi-filtro">Corrispettivi</label>
        <select id="corrispettivi-filtro" name="corrispettiviFiltro" className="db mt3 pa2 w-100"
          value={input.corrispettiviFiltro || ""} onChange={handleChange}>
          <option value="">Nessun filtro corrispettivi</option>
          <option value="CORRISPETTIVI">Solo corrispettivi (SI e split collegati)</option>
        </select>
      </div>
    );
    if (activeTab === "fatture" && mostraFiltroFatture) return <div className="pa3">
      <label htmlFor="fatture-filtro">Stato fattura dell'ordine</label>
      <select id="fatture-filtro" className="db mt3 pa2 w-100" value={input.fattureFiltro || ""}
        onChange={e => setInput({ ...input, fattureFiltro: e.target.value })}>
        <option value="">Nessun filtro fatture</option>
        <option value="DA_EMETTERE">FATTURE DA EMETTERE</option>
        <option value="DA_CONTROLLARE">SPEDIZIONI DA CONTROLLARE</option>
        <option value="INCOMBENTE">FATTURE INCOMBENTI</option>
        <option value="RICHIESTA_NON_EMESSA">Richiesta inviata, non emessa</option>
      </select>
      <p>Il filtro restituisce le spedizioni coinvolte degli ordini corrispondenti.
        Fatture da emettere e fatture incombenti escludono le fatture già emesse; richiesta inviata, non emessa comprende qualunque stato.</p>
    </div>;
    if (activeTab === "magazzino") return <div className="pa3"><label htmlFor="mag-filtro">Stato degli articoli nella spedizione</label>
      <select id="mag-filtro" className="db mt3 pa2 w-100" value={input.magazzinoFiltro || ""} onChange={e=>setInput({...input,magazzinoFiltro:e.target.value})}>
        <option value="">Nessun filtro magazzino</option><option value="TUTTI_PRONTO">Tutti i pezzi PRONTO</option>
        <option value="DA_TROVARE">Almeno un articolo DA TROVARE</option><option value="TROVATO">Almeno un articolo TROVATO</option>
        <option value="PRONTO">Almeno un articolo PRONTO</option><option value="PARZIALE">Almeno un articolo parziale</option>
        <option value="STATI_MULTIPLI">Stati multipli</option><option value="ANOMALIE">Da classificare / quantità incoerenti</option><option value="CUSTOM">Con articoli fuori circuito</option>
      </select><p>Le attestazioni manuali concorrono allo stato PRONTO. I tentativi non confermati non modificano il filtro.</p></div>;
    if (activeTab.startsWith("sql-")) {
      const index = Number(activeTab.replace("sql-", ""));
      return renderSqlColumn(sqlColumns[index] ?? []);
    }
    if (activeTab === "moda") {
      return MODA_SQL_FILTERS.map((field) => {
        const state = getModaState(field);
        return (
          <AdvancedSearchField
            key={field.key}
            label={field.label}
            icon={field.icon}
            active={state.values.length > 0}
            selected={activeValueKey === field.key}
            onClick={() => setActiveValueKey(field.key)}
          />
        );
      });
    }
    if (activeTab === "mongo-web") {
      return CATEGORY_VALUE_FILTERS.map((field) => (
        <AdvancedSearchField
          key={field.key}
          label={field.label}
          icon={field.icon}
          active={isAdvancedSearchValueActive(mongoFilters[field.includeKey])}
          selected={activeValueKey === field.key}
          onClick={() => setActiveValueKey(field.key)}
          hint={activeValueKey === field.key ? field.help : undefined}
        />
      ));
    }
    if (activeTab === "mongo-data") {
      return mongoSelectConfig.map((field) => {
        const state = getMongoSelectState(field);
        return (
          <AdvancedSearchField
            key={field.key}
            label={field.label}
            icon={Tags}
            active={state.values.length > 0}
            selected={activeValueKey === `mongo:${field.key}`}
            onClick={() => setActiveValueKey(`mongo:${field.key}`)}
          />
        );
      });
    }
    return null;
  };

  const renderValueColumn = () => {
    if (activeTab === "moda") {
      const field =
        MODA_SQL_FILTERS.find((item) => item.key === activeValueKey) ??
        MODA_SQL_FILTERS[0];
      const state = getModaState(field);
      const options =
        field.lookupKey === "stagione"
          ? seasonOptions
          : (modaLookupOptions[field.lookupKey] ?? []);
      return (
        <AdvancedSearchValuePicker
          label={field.label}
          options={options}
          selectedValues={state.values}
          mode={state.mode}
          onModeChange={(mode, values) => updateModaValues(field, mode, values)}
          onValuesChange={(values) =>
            updateModaValues(field, state.mode, values)
          }
          tooltip={state.mode === "not_in" ? SQL_NOT_IN_TOOLTIP : undefined}
        />
      );
    }
    if (activeTab === "mongo-web") {
      const field =
        CATEGORY_VALUE_FILTERS.find((item) => item.key === activeValueKey) ??
        CATEGORY_VALUE_FILTERS[0];
      const activeValues = Array.isArray(mongoFilters[field.includeKey])
        ? mongoFilters[field.includeKey]
        : [];
      const currentMode =
        mongoFilters[field.modeKey] ??
        (field.key === "categorieWeb" ? "any" : "none");
      return (
        <div>
          <div className="f5 fw6 mb2">{field.label}</div>
          <div className="f7 gray lh-copy mb3">{field.help}</div>
          {field.modeKey && (
            <div className="flex flex-wrap mb3">
              {(field.key === "categorieWeb"
                ? [
                    { key: "any", label: "ALMENO UNA" },
                    { key: "all", label: "TUTTE" },
                  ]
                : [
                    { key: "missing_any", label: "NE MANCA ALMENO UNA" },
                    { key: "none", label: "TUTTE ASSENTI" },
                  ]
              ).map((mode) => (
                <button
                  key={mode.key}
                  type="button"
                  className="button-reset ba br2 pointer mr2 mb2 pv1 ph2 f7"
                  style={{
                    borderColor:
                      currentMode === mode.key
                        ? "var(--colTastoVerde, #137752)"
                        : "#d1d5db",
                    backgroundColor:
                      currentMode === mode.key
                        ? "rgba(19, 119, 82, 0.12)"
                        : "#fff",
                  }}
                  onClick={() => updateCategoryMode(field, mode.key)}
                >
                  {mode.label}
                </button>
              ))}
            </div>
          )}
          <CategorieWebSub
            onChange={(node, selectedNodes) =>
              updateCategoryValues(field, selectedNodes)
            }
            data={categorieWebTree}
            categorie={activeValues}
          />
        </div>
      );
    }
    if (activeTab === "mongo-data") {
      const mongoKey = String(activeValueKey).replace(/^mongo:/, "");
      const field =
        mongoSelectConfig.find((item) => item.key === mongoKey) ??
        mongoSelectConfig[0];
      if (!field) return null;
      const state = getMongoSelectState(field);
      return (
        <AdvancedSearchValuePicker
          label={field.label}
          options={(field.options ?? []).map((option) => ({
            code: option.idPS ?? option.value,
            description: option.label ?? option.desc,
          }))}
          selectedValues={state.values}
          mode={state.mode}
          modes={[
            { key: "in", label: "IN" },
            { key: "not_in", label: "NOT IN" },
          ]}
          onModeChange={(mode, values) =>
            updateMongoSelectValues(field, mode, values)
          }
          onValuesChange={(values) =>
            updateMongoSelectValues(field, state.mode, values)
          }
          tooltip={state.mode === "not_in" ? MONGO_NOT_IN_TOOLTIP : undefined}
        />
      );
    }
    return null;
  };

  const handleRemoveSummaryEntry = (removeKey) => {
    if (typeof removeKey !== "string") return;
    if (removeKey.startsWith("mongo:")) {
      const key = removeKey.slice("mongo:".length);
      setMongoFilters((prev) => {
        const next = { ...prev };
        delete next[key];
        if (key.endsWith("_in")) {
          delete next[key.slice(0, -3) + "_in_match"];
        }
        if (key.endsWith("_not_in")) {
          delete next[key.slice(0, -7) + "_not_in_match"];
        }
        return next;
      });
      return;
    }
    if (removeKey.startsWith("input:")) {
      const key = removeKey.slice("input:".length);
      setInput((prev) => {
        const next = { ...prev };
        delete next[key];
        return next;
      });
      const modaField = MODA_SQL_FILTERS.find((field) =>
        [field.eqKey, field.includeKey, field.excludeKey].includes(key),
      );
      if (modaField) {
        setModaFilterModes((prev) => ({ ...prev, [modaField.key]: "in" }));
      }
    }
  };

  const handleReset = () => {
    setInput({});
    setMongoFilters({});
    setModaFilterModes(DEFAULT_MODA_FILTER_MODES);
  };

  const applicaSpedizioniInStallo = () => {
    const { dataDa, dataA } = dateSpedizioniInStallo();
    handleReset();
    setInput({
      "sped.`Data` >=": dataDa,
      "sped.`Data` <=": dataA,
      spedizioneFiltro: "NON_SPEDITA",
      corrispettiviFiltro: "CORRISPETTIVI",
    });
  };

  return (
    <AdvancedSearchLayout
      title={noTitle ? "Ricerca avanzata" : "Ricerca avanzata"}
      tabs={tabs}
      activeTab={activeTab}
      onTabChange={setActiveTab}
      filterColumn={renderFilterColumn()}
      valueColumn={renderValueColumn()}
      summaryEntries={summaryEntries}
      onRemoveSummaryEntry={handleRemoveSummaryEntry}
      onClose={setPopUpWindow ? () => setPopUpWindow(false) : undefined}
      onReset={handleReset}
      onApply={runSearch}
      applyLabel="Cerca"
    />
  );
}

export default RicercaAvanzataOrdiniPOP;
